// Sendbird Unread Messages
export const SET_SENDBIRD_UNREAD_MESSAGES = 'SET_SENDBIRD_UNREAD_MESSAGES';